import React from "react";
import ProvileImg from "../assets/image/fadillah.jpg";

const About = () => {
  return (
    <div className="container mx-auto flex flex-wrap items-center p-5 max-lg:mt-28">
      <div className="img-provile flex-auto flex justify-center">
        <img
          src={ProvileImg}
          className="rounded-2xl w-72 max-sm:w-52 border hover:border-sky-900 outline outline-offset-2 hover:outline-2"
          alt="provile-img"
        />
      </div>
      <div className="flex flex-col flex-auto w-3/5">
        <div className="heading">
          <p
            style={{ fontSize: "42px", fontWeight: "bold" }}
            className="py-8 px-10 lg:text-start sm:text-center cursor-default text-sky-500"
          >
            About
          </p>
        </div>
        <div className="body-text">
          <p
            style={{ fontSize: "16px" }}
            className="text-justify tracking-wide px-4 text-base break-words cursor-default"
          >
            Hello, my name is
            <span className="font-bold"> Muhammad Fadillah Abdul Aziz</span>.
            During my studies, I learned about frontend and backend development.
            I also participated in the Campus Merdeka program from Alterra
            Academy in batches 2 and 3. Through this experience, I have the
            ability to design and implement databases, APIs, and UI designs
            created by UI/UX designers. I am able to translate designs into
            functional interfaces and integrate them with the backend system. In
            addition, I have experience participating in organizational
            activities as a hardware lab assistant instructor at the University
            of Computer Indonesia (UNIKOM).
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
